import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

@Component({
  selector: 'cam-kalite-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzInputNumberModule, NzSelectModule,
    CdkTextareaAutosize],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="se">
      <div class="se-baslik">
        <div class="se-baslik-ikon" style="background:linear-gradient(135deg,#0891b2,#06b6d4)">🎯</div>
        <span>Kalite Kontrol</span>
      </div>
      <div class="se-form">
        <div class="form-grup">
          <label>Sonuç <span class="zorunlu">*</span></label>
          <div class="input-wrap">
            <nz-select [ngModel]="p()?.sonuc" (ngModelChange)="guncelle('sonuc', $event)"
              nzPlaceHolder="Kontrol sonucu..." style="width:100%">
              <nz-option nzValue="Kabul" nzLabel="Kabul" nzCustomContent>
                <span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#52c41a"></span> Kabul</span>
              </nz-option>
              <nz-option nzValue="Koşullu" nzLabel="Koşullu Kabul" nzCustomContent>
                <span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#faad14"></span> Koşullu Kabul</span>
              </nz-option>
              <nz-option nzValue="Red" nzLabel="Red" nzCustomContent>
                <span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#ff4d4f"></span> Red</span>
              </nz-option>
            </nz-select>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="se-ayirici"></div>

        <div class="form-satir">
          <div class="form-grup" style="flex:1">
            <label>Ölçülen En (mm)</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="p()?.olculenEn || null" (ngModelChange)="guncelle('olculenEn', $event)"
                [nzMin]="0" [nzStep]="0.1" nzPlaceHolder="En" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup" style="flex:1">
            <label>Ölçülen Boy (mm)</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="p()?.olculenBoy || null" (ngModelChange)="guncelle('olculenBoy', $event)"
                [nzMin]="0" [nzStep]="0.1" nzPlaceHolder="Boy" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup" style="flex:1">
            <label>Ölçülen Yükseklik (mm)</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="p()?.olculenYukseklik || null" (ngModelChange)="guncelle('olculenYukseklik', $event)"
                [nzMin]="0" [nzStep]="0.1" nzPlaceHolder="Yükseklik" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>
        @if (olcu()) {
          <div style="padding:6px 12px;background:rgba(8,145,178,.08);border-radius:8px;margin-top:4px;display:flex;align-items:center;gap:8px">
            <span style="font-size:11px;color:var(--py-metin-ucuncul)">Ölçüm:</span>
            <span style="font-size:14px;font-weight:700;color:#0891b2">{{ olcu() }}</span>
          </div>
        }

        <div class="se-ayirici"></div>

        <div class="form-grup">
          <label>Kontrol Eden</label>
          <div class="input-wrap">
            <input nz-input autocomplete="off"
              [ngModel]="p()?.kontrolEden || ''" (ngModelChange)="guncelle('kontrolEden', $event)"
              placeholder="Kontrol eden kişi..."/>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="se-ayirici"></div>

        <div class="form-grup">
          <label>Notlar</label>
          <div class="input-wrap">
            <textarea nz-input autocomplete="off"
              [ngModel]="p()?.notlar || ''" (ngModelChange)="guncelle('notlar', $event)"
              placeholder="Kalite kontrol notları..." cdkTextareaAutosize [cdkAutosizeMinRows]="2" [cdkAutosizeMaxRows]="4"></textarea>
            <div class="input-glow"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrl: './cam-edit.styles.less',
})
export class CamKaliteEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  constructor() { super(); }

  p = computed(() => this.parametreler()?.ek || {});

  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (params?.ek) { params.ek[alan] = deger; this.parametreler.set({ ...params }); }
  }

  olcu = computed(() => {
    const v = [this.p()?.olculenEn, this.p()?.olculenBoy, this.p()?.olculenYukseklik].filter(x => x);
    return v.length ? v.join(' × ') + ' mm' : '';
  });
}
